import { get as getCookie } from 'js/lib/cookie';

import { device } from '@coursera/event-pulse/sdk';

/**
 * Gets the device ID for logged out Coach mode.
 *
 * Returns the eventing device UUID (from event-pulse), which is the same UUID
 * used for all analytics events, ensuring consistency across the platform for
 * device tracking.
 *
 * @returns Device ID string
 */
export function getDeviceId(): string {
  // The uuid from device sdk is always available and can be used for logout mode.
  return device.get().uuid;
}

/**
 * Gets the cookie ID for logged out Coach mode.
 *
 * Returns the __204u eventing cookie value, which is the server-set cookie used
 * by the eventing service to identify users across sessions. When present, the
 * backend prioritizes this over the deviceId for logged-out user identification.
 *
 * @returns Cookie ID string if the __204u cookie exists, undefined otherwise
 */
export function getCookieId(): string | undefined {
  return getCookie('__204u') || undefined;
}
